import { z } from 'zod';
import { LIMITS } from '../constants';
import { paginationQuerySchema } from './common';
/**
 * Metadata accompanying an upload. The file itself arrives as multipart, so it
 * is validated by the interceptor (size, declared MIME) and then by content
 * sniffing in MediaService — a client-supplied `Content-Type` is a hint, not
 * evidence.
 */
export const uploadMediaMetaSchema = z.object({
    /**
     * Screen-reader text. Not optional-by-omission: an empty string is a valid,
     * meaningful value for a purely decorative image, but forgetting the field
     * entirely usually means nobody thought about it.
     */
    altText: z.string().trim().max(LIMITS.altText.max).default(''),
    title: z.string().trim().max(200).optional(),
});
export const updateMediaSchema = z.object({
    altText: z.string().trim().max(LIMITS.altText.max).optional(),
    title: z.string().trim().max(200).nullish(),
});
export const mediaQuerySchema = paginationQuerySchema.extend({
    q: z.string().trim().max(120).optional(),
    mimePrefix: z.string().trim().max(40).optional(),
});
/**
 * Build the `srcset` for a responsive <img>.
 *
 * Lives in shared rather than in a React component so the same widths are used
 * by any future consumer — an email template, an OG-image renderer, an RSS feed.
 */
export function buildSrcSet(asset) {
    return asset.variants
        .filter((variant) => variant.variant !== 'original')
        .sort((a, b) => a.width - b.width)
        .map((variant) => `${variant.url} ${variant.width}w`)
        .join(', ');
}
//# sourceMappingURL=media.js.map